module.exports = __webpack_public_path__ + "assets/img/logoaiq.2a18faaf.png";